exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-edit[data-v-7bb21c82]{outline:1px dashed #dcdfe6;background-color:#fff}.paragraph[data-v-7bb21c82]{height:32px;box-sizing:border-box;padding:5px}.paragraph-edit[data-v-7bb21c82]{width:100%;height:100%;outline:none;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7bb21c82","scoped":true,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/block/block.vue
// module id = 86
// module chunks = 0